import React from 'react';
import styled from 'styled-components';
import { Box, SolvTheme } from '@solvhealth/jigsaw-v1';
import Carrier from './components/Carrier';
import { safeGet } from '../../../../../../core/util/object';
import UpdateInsuranceMenu from './components/UpdateInsuranceMenu';
import PlanDetails from './components/PlanDetails';
import CarrierContactInfo from './components/CarrierContactInfo';
import useInsuranceCarrierDisplayProperties from './hooks/useInsuranceCarrierDisplayProperties';
import useSelectInsuranceProfile from '../../../../hooks/useSelectInsuranceProfile';
import { colors } from '../../../../../../constants/colors';

const Root = styled.div.withConfig({ componentId: 'sc-r01eps-0' })`
  z-index: 1;
  width: 344px;
  max-width: 344px;
  border-radius: 15px;
  background-color: ${colors.theWhiteAlbum};
  box-shadow: ${SolvTheme.shadows.sm};
  text-align: left;
`;

const HeaderContainer = styled.div.withConfig({ componentId: 'sc-r01eps-1' })`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${SolvTheme.space[2]};
`;

type Props = {
  userProfileId: string;
};

const InsuranceCard = (props: Props) => {
  const { userProfileId } = props;
  const insuranceCarrierDisplayProperties = useInsuranceCarrierDisplayProperties(userProfileId);
  const insuranceProfile = useSelectInsuranceProfile(userProfileId);

  return (
    <Root>
      <Box mb={3} mt={2} mx={4}>
        <HeaderContainer>
          <Carrier
            insuranceCarrierName={safeGet(insuranceProfile)('insurer_name')}
            logo={safeGet(insuranceCarrierDisplayProperties)('logo')}
          />
          <UpdateInsuranceMenu userProfileId={userProfileId} />
        </HeaderContainer>

        <PlanDetails userProfileId={userProfileId} />
      </Box>

      <CarrierContactInfo userProfileId={userProfileId} />
    </Root>
  );
};

export default InsuranceCard;
